(ns app.front.view.property.issues
  (:require [app.front.ui.error-boundary :as eb]
            [app.front.ui.table :as ui-table]
            [app.front.util :refer [for-frag]]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx ::init
  (fn [{:keys [db]} [_ phase]]
    {:db           (assoc db ::data {::loading? true ::modal-open? true})
     :comm/command {:command          :property/external-issues
                    :data             {:phase-id (:db/id phase)}
                    :on-success       [::init.success]
                    :finally-dispatch [::init.done]}}))


(rf/reg-event-db ::init.success
  (fn [db [_ _ response]]
    (assoc-in db [::data ::properties] response)))


(rf/reg-event-db ::init.done
  (fn [db _]
    (p/dissoc-in db [::data ::loading?])))


(rf/reg-event-db ::close-modal
  (fn [db _]
    (dissoc db ::data)))


(rf/reg-sub ::data :-> ::data)


(defn external-issues-modal [tr]
  (let [{::keys [modal-open? loading? properties]} (<sub [::data])]
    (cc/composed-modal
      {:open     modal-open?
       :on-close #(>evt [::close-modal])}
      (cc/modal-header {:close-modal #(>evt [::close-modal])
                        :title       (tr [:property/issues-modal-title])})
      (cc/modal-body
        {}
        [eb/error-boundary
         [:div.property-owner-info-modal
          (if loading?
            (cc/skeleton-text {:paragraph  true
                               :line-count 10})
            (for-frag [{:property/keys [id integration-id tax-account-status open-cases address]} properties]
              [:div.mb-6
               [:h4 (str/join " / " [address
                                     id
                                     (str (<sub [::ws-subs/backend-system-name]) " ID " integration-id)])]
               [:div.mt-3
                [:h5 (tr [:property/tax-account-status])]
                [:div.text-sm.mt-2 tax-account-status]]
               [:div.mt-3
                [:h5.mb-3 (tr [:property/open-cases])]
                #_{:clj-kondo/ignore [:deprecated-var]}
                [ui-table/responsive-table
                 {:row-class-override    "p-2 lg:items-start border-b border-solid border-ui-gray"
                  :header-class-override "p-2 bg-ui-gray font-bold"}
                 [{:title (tr [:property-case/external-id])
                   :width "80px"}
                  {:title (tr [:property-case/status])}
                  {:title (tr [:property-case/case-type])}
                  {:title (tr [:property-case/created])}
                  {:title     (tr [:property-case/description])
                   :min-width "33%"}]
                 (for [{:property-case/keys [external-id case-type created status description]} (->> open-cases
                                                                                                     (sort-by > :property-case/created))]
                   {:key  external-id
                    :cols [{:content external-id}
                           {:content status}
                           {:content case-type}
                           {:content ((<sub [::date-util/date-fn]) created)}
                           {:content description}]})]]]))]])
      (cc/modal-footer
        {}
        (cc/button
          {:kind     :primary
           :on-click #(>evt [::close-modal])}
          (tr [:close]))))))
